var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_35208_79902)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.3036,
    stroke: "#50FB80",
    strokeWidth: 2.60714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_35208_79902)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.0013,
    cy: 27.9989,
    r: 21.4286,
    fill: "#03AF30"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4908 22.6524C35.3871 22.5478 35.2637 22.4648 35.1277 22.4081C34.9916 22.3514 34.8458 22.3223 34.6984 22.3223C34.5511 22.3223 34.4052 22.3514 34.2692 22.4081C34.1332 22.4648 34.0098 22.5478 33.906 22.6524L25.5913 30.9783L22.098 27.4738C21.9903 27.3698 21.8631 27.2879 21.7237 27.233C21.5844 27.1781 21.4356 27.1512 21.2858 27.1538C21.1361 27.1564 20.9883 27.1884 20.851 27.2481C20.7136 27.3078 20.5893 27.394 20.4853 27.5017C20.3812 27.6095 20.2994 27.7366 20.2445 27.876C20.1896 28.0153 20.1626 28.1641 20.1652 28.3139C20.1678 28.4636 20.1999 28.6114 20.2596 28.7488C20.3193 28.8861 20.4054 29.0104 20.5132 29.1145L24.7989 33.4002C24.9026 33.5048 25.0261 33.5878 25.1621 33.6445C25.2981 33.7011 25.444 33.7303 25.5913 33.7303C25.7386 33.7303 25.8845 33.7011 26.0205 33.6445C26.1565 33.5878 26.28 33.5048 26.3837 33.4002L35.4908 24.293C35.6041 24.1885 35.6945 24.0617 35.7564 23.9205C35.8182 23.7793 35.8501 23.6268 35.8501 23.4727C35.8501 23.3186 35.8182 23.1661 35.7564 23.0249C35.6945 22.8838 35.6041 22.7569 35.4908 22.6524Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_35208_79902",
    x: -111.342,
    y: -111.342,
    width: 278.683,
    height: 278.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 55.8673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_35208_79902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_35208_79902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_35208_79902",
    x: -105.162,
    y: -105.164,
    width: 266.326,
    height: 266.327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 55.8673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_35208_79902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_35208_79902",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.7693749641cd201c8a8c3f3949ac464e.svg";
export { ForwardRef as ReactComponent };